'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGwAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.95801e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000126198 6.66667 1.95801e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V9.33333H0V20Z",
          fill: "#1AB558"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 9.33333H28V0H1.95801e-05L0 9.33333Z",
          fill: "#FFD952"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H10.6667V0H1.95801e-05L0 20Z",
          fill: "#E72B42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33333 11.2784L3.37405 12.6967L4.11754 10.395L2.16314 8.96994L4.58193 8.96578L5.33333 6.66667L6.08473 8.96578L8.50352 8.96994L6.54913 10.395L7.29262 12.6967L5.33333 11.2784Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagGwAsset = forwardRef(FlagGwAsset);

export { VpFlagGwAsset as default };
